// AdminWidgetsSpec.staff-companies.js — 직원 그룹 회사별 위젯 entry (2026-06-08)
//
// 사용자 명세: 관리자라도 PINE 급여, DOT 급여, LNJ 급여 각각 분리된 위젯.
// 위젯 코드: admin_payroll_pine / admin_payroll_dot / admin_payroll_lnj (incentive/renewal 동일).
// 라벨 형식: "급여 (PINE)" / "급여 (DOT)" / "급여 (LNJ)" — 영어 회사 코드.
//
// 본 파일은 spec entry 만 정의. render 함수 / monthLabel 은 .staff-renders.js 에서 import
// (.staff.js 와 circular import 회피 — renders 는 spec 본문에 의존하지 않음).

import { Wallet, Gift, FileClock } from 'lucide-react';
import { WIDTHS } from './widgetFormat';
import {
  renderPayrollMonthTotal,
  renderIncentiveMonthTotal,
  renderRenewal,
  monthLabel,
} from './AdminWidgetsSpec.staff-renders';

// 3사 명시 (사용자 명세). 신규 외부회사 추가 시 본 배열에 추가하면 위젯 자동 노출.
const COMPANIES = ['PINE', 'DOT', 'LNJ'];

function payrollEntry(cc) {
  return [`admin_payroll_${cc.toLowerCase()}`, {
    Icon: Wallet, label: `급여 (${cc})`, width: WIDTHS.WIDE, accent: 'violet', size: 'S',
    render: renderPayrollMonthTotal,
    monthNavigate: true,
    monthLabel,
    watermarkIcon: Wallet,
  }];
}

function incentiveEntry(cc) {
  return [`admin_incentive_${cc.toLowerCase()}`, {
    Icon: Gift, label: `인센 (${cc})`, width: WIDTHS.WIDE, accent: 'pink', size: 'S',
    render: renderIncentiveMonthTotal,
    monthNavigate: true,
    monthLabel,
    watermarkIcon: Gift,
  }];
}

function renewalEntry(cc) {
  return [`admin_renewal_${cc.toLowerCase()}`, {
    Icon: FileClock, label: `갱신 (${cc})`, width: WIDTHS.WIDE, accent: 'indigo', size: 'S',
    render: renderRenewal,
    watermarkIcon: FileClock,
  }];
}

// 회사별 위젯을 코드로 만들어 주는 함수들 — 목록에 없는 회사는 AdminWidgetsSpec.company-dynamic.js 가
//   이 함수들을 그대로 불러 만든다 (2026-09-10). 위 COMPANIES 배열은 기존 3사용으로 남겨 둔다.
export const STAFF_COMPANY_ENTRY_BUILDERS = {
  admin_payroll: payrollEntry,
  admin_incentive: incentiveEntry,
  admin_renewal: renewalEntry,
};

export const STAFF_COMPANY_SPECS = Object.fromEntries([
  ...COMPANIES.map(payrollEntry),
  ...COMPANIES.map(incentiveEntry),
  ...COMPANIES.map(renewalEntry),
]);
